import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CaretRight } from "@phosphor-icons/react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

export default function LegalLayout({
  overline,
  title,
  accent,
  intro,
  updated,
  children,
  testid,
}) {
  return (
    <div data-testid={testid} className="min-h-screen bg-altin-bg">
      <Navbar />

      {/* Page hero */}
      <section className="pt-36 md:pt-44 pb-16 md:pb-20 bg-altin-ink relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, #C5A059 1px, transparent 0)",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="relative max-w-5xl mx-auto px-6 md:px-12">
          <nav className="flex items-center gap-2 text-xs text-white/50 mb-8 uppercase tracking-[0.2em]">
            <Link to="/" className="hover:text-altin-gold transition-colors">
              Home
            </Link>
            <CaretRight size={12} weight="light" />
            <span className="text-altin-gold">{overline}</span>
          </nav>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-serif-display text-4xl md:text-6xl leading-[1.03] text-white tracking-tight">
              {title}{" "}
              {accent && <span className="italic text-altin-gold">{accent}</span>}
            </h1>
            {intro && (
              <p className="mt-6 text-lg text-white/70 font-light leading-relaxed max-w-2xl">
                {intro}
              </p>
            )}
            {updated && (
              <p className="mt-6 text-xs uppercase tracking-[0.25em] text-white/40">
                Last updated · {updated}
              </p>
            )}
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-6 md:px-12">{children}</div>
      </section>

      <Footer />
    </div>
  );
}

export function LegalSection({ index, title, children, id }) {
  return (
    <div
      id={id}
      className="py-10 border-b border-altin-border last:border-0"
      data-testid={id}
    >
      <div className="flex items-baseline gap-5">
        {index && (
          <span className="font-serif-display text-3xl text-altin-gold/40 shrink-0">
            {index}
          </span>
        )}
        <div className="flex-1">
          <h2 className="font-serif-display text-2xl md:text-3xl text-altin-ink tracking-tight">
            {title}
          </h2>
          <div className="mt-4 space-y-4 text-altin-muted leading-relaxed">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
